import { TextFieldProps } from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { TFunction } from 'i18next';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseField } from './field.styles';

type BaseFieldProps = TextFieldProps;

export type Option =
  | {
      label: string;
      labelElement?: React.ReactNode;
      value: any;
    }
  | string;

interface Props {
  options?: Option[];
  namespace?: string;
  translateOptions?: boolean;
}

const mapOptions = (options: Option[], t: TFunction, translate: boolean) =>
  options.map((option) => {
    const label = typeof option === 'object' ? option.label : option;
    const labelElement =
      typeof option === 'object' ? option.labelElement : option;
    const value = typeof option === 'object' ? option.value : option;
    const key = typeof option === 'object' ? option.label : option;
    return (
      <MenuItem key={key} value={value}>
        {translate ? t(label) : labelElement || label}
      </MenuItem>
    );
  });

export type FieldProps = Props & BaseFieldProps;

const Field: React.ForwardRefExoticComponent<FieldProps> = forwardRef(
  ({ options, namespace, translateOptions = false, ...props }, ref) => {
    const { t } = useTranslation(namespace);
    return (
      <BaseField
        ref={ref}
        variant="filled"
        fullWidth
        {...props}
        children={
          options ? mapOptions(options, t, translateOptions) : props.children
        }
      />
    );
  }
);

export default Field;
